module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idgenobjectstyleoverride",
    attrs: {
      "id": "_idContainer1347"
    }
  }, [_c('p', {
    staticClass: "structure-prep-infos",
    attrs: {
      "id": "calibre_pb_59"
    }
  }, [_vm._v("Prep Time: "), _c('span', {
    staticClass: "prep-time-blue"
  }, [_vm._v("1 minute")]), _vm._v(" • Cooking Time: "), _c('span', {
    staticClass: "prep-time-blue"
  }, [_vm._v("13 minutes")]), _vm._v(" • Makes: "), _c('span', {
    staticClass: "prep-time-blue"
  }, [_vm._v("1 serving")])]), _vm._v(" "), _c('p', {
    staticClass: "icon"
  }, [_vm._v("Vegan • "), _c('span', {
    staticClass: "bold6"
  }, [_c('img', {
    staticClass: "_idgenobjectattribute7",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/no-glluten1.png"
    }
  })]), _c('img', {
    staticClass: "_idgenobjectattribute7",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/no-eggs.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idgenobjectattribute7",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/no-dairy1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "body_heading-recipe"
  }, [_c('span', {
    staticClass: "heading-red"
  }, [_vm._v("Quinoa ")]), _vm._v("Breakfast Bowl")]), _vm._v(" "), _c('ul', {
    staticClass: "calibre4"
  }, [_c('li', {
    staticClass: "body_ingredients"
  }, [_vm._v("¼ "), _c('span', [_vm._v("cup")]), _c('span'), _c('span', [_vm._v("quinoa")])]), _vm._v(" "), _c('li', {
    staticClass: "body_ingredients"
  }, [_vm._v("1 tablespoon coc"), _c('span', [_vm._v("onut")]), _c('span'), _c('span', [_vm._v("cream")])]), _vm._v(" "), _c('li', {
    staticClass: "body_ingredients"
  }, [_vm._v("Granola, f"), _c('span', [_vm._v("or")]), _c('span'), _c('span', [_vm._v("garnish")])]), _vm._v(" "), _c('li', {
    staticClass: "body_ingredients"
  }, [_vm._v("Yogurt, f"), _c('span', [_vm._v("or")]), _c('span'), _c('span', [_vm._v("garnish")])]), _vm._v(" "), _c('li', {
    staticClass: "body_ingredients"
  }, [_vm._v("Fresh fruit, f"), _c('span', [_vm._v("or")]), _c('span'), _c('span', [_vm._v("garnish")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_youtube"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/you-tube-black.png"
    }
  }), _vm._v("\tTo watch the video tutorial for this recipe, search “FlavCity What I Eat in a Day” on YouTube.")]), _vm._v(" "), _c('p', {
    staticClass: "shopping-tip-centered-2col"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/image-308.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "shopping-tip-centered-2col"
  }, [_vm._v("When buying "), _c('span', {
    staticClass: "shopping-tip-bold-red1"
  }, [_vm._v("coconut cream")]), _vm._v(", look for brands that don’t add emulsifiers like guar gum. Although it’s very common in nondairy milk, it’s not needed in coconut milk. Too many gums can upset your stomach. My favorite brand is Let’s Do Organic. They also make the best coconut milk, called Native Forest. Thrive Market and Trader Joe’s make my second-favorite coconut milk "), _c('span', [_vm._v("and")]), _c('span'), _c('span', [_vm._v("cream.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-339b3f30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/5Ingredient_split_036.vue
// module id = 165
// module chunks = 0